import React from "react"
import { CCPARequest } from "reaction/Components/CCPARequest"

export const ReactionCCPARequest = props => <CCPARequest {...props} />
